import React, { InputHTMLAttributes, ReactNode, useCallback } from 'react';
import InputFrame from '../atoms/InputFrame';

interface NumberEditProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'prefix' | 'onChange'> {
    label: string;
    errorMessage?: string;
    className?: string;
    labelClassName?: string;
    prefix?: ReactNode;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const NumberEdit: React.FC<NumberEditProps> = ({
    prefix,
    label,
    errorMessage,
    className,
    labelClassName,
    onChange,
    ...restProps
}) => {
    let textColor = "text-gray-900 dark:text-gray-100";
    let focusColor = "focus:border-blue-600 dark:focus:border-blue-400";

    if (errorMessage) {
        textColor = "text-red-700 dark:text-red-400";
        focusColor = "focus:border-red-600 dark:focus:border-red-400";
    }

    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const onlyNumbers = e.target.value.replace(/\D/g, '');
            const modifiedEvent = {
                ...e,
                target: {
                    ...e.target,
                    value: onlyNumbers,
                }
            };
            onChange?.(modifiedEvent as React.ChangeEvent<HTMLInputElement>);
        },
        [onChange]
    );

    return (
        <InputFrame
            label={label}
            errorMessage={errorMessage}
            className={className}
            prefix={prefix}
            textColor={textColor}
            labelClassName={labelClassName}
        >
            <input
                type="text"
                inputMode="numeric"
                className={`block py-2.5 px-0 w-full text-sm ${textColor} bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 ${focusColor} peer disabled:opacity-50 disabled:cursor-not-allowed dark:text-white`}
                placeholder=" "
                onChange={handleChange}
                {...restProps}
            />
        </InputFrame>
    );
};

export default NumberEdit;
